import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import Field, { FieldPrefix } from '../../../../../../../../../../1stlog-ui/src/components/Field'
import TimePicker from '../../../../../../../../../../1stlog-ui/src/components/TimePicker'

const Wrapper = styled.div``

const FixedWindow = (props) => {
  const {} = props

  return (
    <Wrapper>
      <div className="text-muted">
        {i18n.t('it_is_mandatory_that_the_requested_delivery_pickup_be_provided_on_the_commissioned_day_within_the_specified_time_range_an_earlier_or_later_delivery_pickup_is_generally_inadmissible',
                'Die gewünschte Zustellung/Abholung ist zwingend an dem beauftragten Tag innerhalb des angegebenen Zeitfensters zu erbringen. Eine frühere oder spätere Zustellung/Abholung ist generell unzulässig.')}
      </div>
      <div className="mt-1">
        <FieldPrefix name="timeWindow">
          <div className="d-flex align-items-center">
            <Field name="start">
              <TimePicker />
            </Field>
            <div className="mx-2" style={{ marginBottom: '5px' }}>
              {i18n.t(`to`, `bis`)}
            </div>
            <Field name="end">
              <TimePicker />
            </Field>
          </div>
        </FieldPrefix>
      </div>
    </Wrapper>
  )
}

export default FixedWindow
